var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriasRefeicao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#F18184",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_760_5410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8047 5.529C17.6133 5.33834 17.3273 5.28101 17.078 5.38434C16.8287 5.48767 16.6667 5.73099 16.6667 6.00031V18.6665H18V14.6666H19.3333C19.7013 14.6666 20 14.368 20 14C20 7.79557 17.8947 5.619 17.8047 5.529ZM18 13.3333V8.82886C18.3247 9.89548 18.6053 11.3674 18.658 13.3333H18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 8.0002V5.33364H8V8.0002C8 8.49151 7.73 8.91683 7.33333 9.14882V5.33364H6V9.14882C5.60333 8.91683 5.33333 8.49218 5.33333 8.0002V5.33364H4V8.0002C4 9.23882 4.85333 10.2734 6 10.5721V18.6664H7.33333V10.5721C8.48 10.2734 9.33333 9.23882 9.33333 8.0002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.0001C9.794 10.0001 8 11.7941 8 14C8 16.2059 9.794 17.9998 12 17.9998C14.206 17.9998 16 16.2059 16 14C16 11.7941 14.206 10.0001 12 10.0001ZM12 16.6665C10.5293 16.6665 9.33333 15.4706 9.33333 14C9.33333 12.53 10.5293 11.3334 12 11.3334C13.4707 11.3334 14.6667 12.53 14.6667 14C14.6667 15.4706 13.4707 16.6665 12 16.6665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12.6667C12.448 12.6667 12 13.1147 12 13.6666C12 13.1147 11.552 12.6667 11 12.6667C10.448 12.6667 10 13.1147 10 13.6666C10 14.6666 12 15.9999 12 15.9999C12 15.9999 14 14.6666 14 13.6666C14 13.1147 13.552 12.6667 13 12.6667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_760_5410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriasRefeicao);
export default __webpack_public_path__ + "static/media/categorias-refeicao.eee8d0783c5bfc0d4849876f98adf76b.svg";
export { ForwardRef as ReactComponent };